import { render, staticRenderFns } from "./UISearch.vue?vue&type=template&id=5b238160&"
import script from "./UISearch.vue?vue&type=script&lang=js&"
export * from "./UISearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports